import * as React from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import { NoteService } from '../../services/noteService';
import ICreateModal from './interfaces/createModal';
import INotesAppState from './interfaces/notesAppState';
import { actionCreators } from './redux/actions';

class CreateBookmarkModal extends React.Component<ICreateModal, null> {
    render() {
        return (
            createPortal(
                <React.Fragment>
                    {
                        this.props.display
                            ? <div className="bookmarks__modal" onClick={(event) => event.stopPropagation()}>
                                <div className="bookmarks__modal-backdrop"></div>
                                <div className="bookmarks__modal-innercontainer">
                                    <button onClick={(event) => this.props.toggleCreateModal(event)} className="modal__close">Stäng</button>
                                    <div className="modal__content">
                                        <h2 className="modal__title">Lägg till kategori</h2>
                                        <div className="share-content">
                                            <div className="form-field  share-content__form-field">
                                                <input type="text" id="categoryName" className="share-content__email" placeholder="Ange ett namn för kategorin" maxLength={50} autoComplete="off" autoFocus value={this.props.newCategoryName} onChange={(event) => this.props.setNewCategoryName(event, this.props.buttonIsDisabled)} />
                                                <label className="share-content__label" htmlFor="categoryName">Namn på kategori</label>
                                            </div>
                                        </div>
                                        <div className="modalCTAs">
                                            <button className="genericBtn alternate" onClick={(event) => this.props.toggleCreateModal(event, this.props.newCategoryName)}>Avbryt</button>
                                            <button className="genericBtn primary" disabled={this.props.buttonIsDisabled} onClick={(event) => this.props.createNewCategory(event, this.props.newCategoryName, this.props.categories)}>Skapa</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null
                    }
                </React.Fragment>,
                document.body)
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps): ICreateModal => {
    const noteService = new NoteService();
    return {
        ...ownProps,
        toggleCreateModal: (event, newCategoryName?) => {
            event.preventDefault();
            dispatch(actionCreators.toggleCreateModal());
            if (newCategoryName) {
                dispatch(actionCreators.setNewCategoryName(''));
            }
        },
        createNewCategory: (event, newCategoryName, categories) => {
            event.preventDefault();
            if (newCategoryName) {
                noteService.createCategory({ name: newCategoryName }, (response) => {
                    if (response) {
                        if (categories) {
                            const c = [...categories];
                            if (response && response.id && response.name) {
                                const edited = {
                                    categoryId: response.id,
                                    categoryName: response.name
                                };
                                c.push(edited);
                            }
                            const sorted = c.sort((a, b) => {
                                if (a.categoryName && b.categoryName) {
                                    if (a.categoryName > b.categoryName) {
                                        return 1;
                                    }
                                    return -1;
                                }
                            })
                            dispatch(actionCreators.setAllCategories(sorted));
                        }

                        dispatch(actionCreators.toggleCreateModal());
                        dispatch(actionCreators.setToastBarType('success'));
                        dispatch(actionCreators.setToastBarMessage('Kategori skapad'));
                        dispatch(actionCreators.toggleToastBar());

                        if (newCategoryName) {
                            dispatch(actionCreators.setNewCategoryName(''))
                        }

                    }

                }, (error) => {
                    dispatch(actionCreators.setToastBarType('warn'));
                    dispatch(actionCreators.setToastBarMessage('Kunde inte skapa ny kategori'));
                    dispatch(actionCreators.toggleToastBar());
                    console.error(error);
                });
            }
        },
        setNewCategoryName: (event, buttonIsDisabled) => {
            event.preventDefault();
            if (buttonIsDisabled) {
                dispatch(actionCreators.toggleCreateModalButton())
            }
            dispatch(actionCreators.setNewCategoryName(event.target.value))
        }
    };
}

const mapStateToProps = (state: INotesAppState): ICreateModal => {
    return { display: state.displayCreateModal, newCategoryName: state.newCategoryName, categories: state.categories, buttonIsDisabled: state.createModalButtonIsDisabled };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateBookmarkModal);